export const attachHelpIconHandlers = (helpIcon) => {
  helpIcon.addEventListener("mouseover", togglePopup);
  helpIcon.addEventListener("mouseout", togglePopup);
}

const togglePopup = (event) => event.currentTarget.querySelector(".tooltip").classList.toggle("show");

window.addEventListener("DOMContentLoaded", (event) => {
  $$(".help-icon").forEach(attachHelpIconHandlers);
})